import { IRequestDemandState } from '../../types/requestDemand';
import { TDemandRequestActions } from '../../actions/requestDemand';
import { ERequestDemandActionTypes } from '../../constants/actionTypes/requestDemand';
import { EUserType } from '../../constants/requestDemand';

const defaultState: IRequestDemandState = {
  isDemandRequestOpen: false,
  isSuccessModalOpen: false,
  isFetching: false,
  isSmsVerificationModalOpen: false,
  selectedUserType: EUserType.USER,
  error: '',
};
export const requestDemandReducer = (
  state: IRequestDemandState = defaultState,
  { type, payload }: TDemandRequestActions,
) => {
  switch (type) {
    case ERequestDemandActionTypes.OPEN_DEMAND_REQUEST_MODAL:
      return {
        ...state,
        isDemandRequestOpen: true,
      };
    case ERequestDemandActionTypes.CLOSE_DEMAND_REQUEST_MODAL:
      return {
        ...defaultState,
      };
    case ERequestDemandActionTypes.OPEN_DEMAND_SMS_VERIFICATION_MODAL:
      return {
        ...state,
        isSmsVerificationModalOpen: true,
      };
    case ERequestDemandActionTypes.CLOSE_DEMAND_SMS_VERIFICATION_MODAL:
      return {
        ...state,
        isSmsVerificationModalOpen: false,
      };
    case ERequestDemandActionTypes.OPEN_DEMAND_SUCCESS_MODAL:
      return {
        ...state,
        isSuccessModalOpen: true,
      };
    case ERequestDemandActionTypes.CLOSE_DEMAND_SUCCESS_MODAL:
      return {
        ...state,
        isSuccessModalOpen: false,
      };
    case ERequestDemandActionTypes.DEMAND_REQUEST_SEND_START:
      return {
        ...state,
        lastDemandRequest: payload,
        isFetching: true,
      };
    case ERequestDemandActionTypes.DEMAND_REQUEST_SEND_SUCCESS:
      return {
        ...state,
        isFetching: false,
      };
    case ERequestDemandActionTypes.DEMAND_REQUEST_SEND_ERROR:
      return {
        ...state,
        isFetching: false,
        error: payload,
      };
    case ERequestDemandActionTypes.DEMAND_CHANGE_USER_TYPE:
      return {
        ...state,
        selectedUserType: payload,
      };
  }

  return state;
};
